// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (c) 2026 Password Manager contributors
/**
 * Privacy Policy Page Route
 *
 * Public privacy policy page for Password Manager.
 * Accessible without authentication.
 * GDPR and CCPA compliant with international provisions.
 *
 * @module routes/privacy
 */

import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/privacy")({
  component: () => <Navigate to="/privacy-policy" replace />,
});
